// src/components/layout/AppShell.js
import React, { useState, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import BottomNav from './BottomNav'
import QuickAddTransaction from '../QuickAddTransaction'
import { theme } from '../../lib/theme'
import { emitDataEvent, EVENTS } from '../../lib/dataEvents'

export default function AppShell() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [showInstallBanner, setShowInstallBanner] = useState(false)
  const [showQuickAdd, setShowQuickAdd] = useState(false)
 

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
    const isDismissed = localStorage.getItem('installBannerDismissed')
    if (isMobile && !isStandalone && !isDismissed) {
      setShowInstallBanner(true)
    }
  }, [isMobile])

  const handleDismissBanner = () => {
    localStorage.setItem('installBannerDismissed', 'true')
    setShowInstallBanner(false)
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const isAndroid = /Android/.test(navigator.userAgent)

  return (
    <div className="app-shell" style={styles.shell}>
      {!isMobile && <Sidebar />}
      <div style={styles.main}>

        {showInstallBanner && (
          <div style={styles.installBanner}>
            <div style={styles.installLeft}>
              <div style={{ minWidth: 0 }}>
                <div style={styles.installTitle}>Add Merq Vault to your home screen</div>
                <div style={styles.installSub}>
                  {isIOS
                    ? 'Tap Share → Add to Home Screen'
                    : isAndroid
                      ? 'Tap Menu → Add to Home Screen'
                      : 'Install for the best experience'
                  }
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn-compact"
              style={styles.installDismiss}
              onClick={handleDismissBanner}
              aria-label="Dismiss install banner"
            >
              ×
            </button>
          </div>
        )}

        <div style={{
          ...styles.content,
          padding: isMobile ? '16px 0' : '24px',
          paddingBottom: isMobile ? '96px' : '24px',
        }}>
          <Outlet context={{ isMobile, openQuickAdd: () => setShowQuickAdd(true) }} />
        </div>

        {isMobile && <BottomNav onAddTransaction={() => setShowQuickAdd(true)} />}
      </div>

      {showQuickAdd && (
        <QuickAddTransaction
          onClose={() => setShowQuickAdd(false)}
          onSaved={() => {
            setShowQuickAdd(false)
            emitDataEvent(EVENTS.TRANSACTION_SAVED)
          }}
        />
      )}
    </div>
  )
}

// ─────────────────────────────────────────────────────────────
// Styles
// ─────────────────────────────────────────────────────────────

const c = theme.colors
const f = theme.fonts

const styles = {
  shell: {
    display: 'flex',
    minHeight: '100vh',
    background: c.cream,
    fontFamily: f.body,
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    position: 'relative',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
  },
  installBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: c.plum,
    padding: '12px 16px',
    gap: '12px',
  },
  installLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    minWidth: 0,
  },
  installIcon: {
    color: c.greenMint,
    flexShrink: 0,
  },
  installTitle: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#FFFFFF',
    marginBottom: '2px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  installSub: {
    fontSize: '12px',
    color: c.greenMint,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  installDismiss: {
    background: 'transparent',
    border: 'none',
    color: 'rgba(255,255,255,0.6)',
    cursor: 'pointer',
    padding: '6px',
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '6px',
    fontSize: '20px',
    lineHeight: 1,
  },
}
